// extracted by mini-css-extract-plugin
module.exports = {"switch":"Admin_switch__1N-a7","spinner":"Admin_spinner__3hACb"};